import React from 'react'
import { Box, Tooltip } from '@mui/material'
import { useDemoJobInfo } from '../../pages/admin/useDemos'

export interface DemoBadgeProps {
  customer?: string
  job?: string
}

/**
 * "Demo" beside the job name in the top bar, on a job of a demo story
 * (design/2026-10-22-chief-of-staff-and-demos.md T20), so nobody takes its
 * fictional numbers for a customer's. Nothing on any other job, and nothing
 * while the answer is not in.
 */
const DemoBadge: React.FC<DemoBadgeProps> = ({ customer, job }) => {
  const { info } = useDemoJobInfo(customer, job)
  if (!info?.is_demo) return null
  const what = `Demo job: ${info.title || info.story || job}. Its data is fictional and is reset on Admin → Demos.`
  return (
    <Tooltip title={what}>
      <Box
        component="span"
        role="status"
        aria-label={what}
        data-testid="demo-badge"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          height: 22,
          px: 1,
          borderRadius: 11,
          border: '1px solid',
          borderColor: 'info.light',
          color: 'info.light',
          fontSize: '0.6875rem',
          fontWeight: 700,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}
      >
        Demo
      </Box>
    </Tooltip>
  )
}

export default DemoBadge
